import { Container, Pagination, styled } from '@mui/material';
import {
  IApiCallStatus,
  ISaveRequestOutput,
  ValueLabel,
  variables,
} from '../common';
import { IMoreRequestData, renderStack, RequestStatusType } from '.';
import { useState } from 'react';

export function RequestStatusStack({
  properties,
  requests,
  getRequstsCallStatus,
  expandRequestValue,
  toggleExpandRequest,
  moreRequestData,
  requestStatusType,
  disableOperationsHelpDsk,
  now,
  selectedRequests,
  toggleRequestSelection,
  confirmCancelRequests,
}: {
  properties: ValueLabel<keyof ISaveRequestOutput>[];
  requests: ISaveRequestOutput[];
  getRequstsCallStatus: IApiCallStatus;
  expandRequestValue: (name: string) => boolean;
  toggleExpandRequest: (name: string) => void;
  moreRequestData: IMoreRequestData[];
  requestStatusType: RequestStatusType;
  disableOperationsHelpDsk: boolean;
  now?: Date;
  selectedRequests?: ISaveRequestOutput[];
  toggleRequestSelection?: (payload: ISaveRequestOutput) => void;
  confirmCancelRequests?: () => void;
}) {
  const s = Paginatio;
  const [page, setPage] = useState(1);
  const pageSize = 100;
  switch (getRequstsCallStatus) {
    case null:
      return <Container maxWidth="lg">Loading...</Container>;

    case false:
      return <Container maxWidth="lg">Error</Container>;

    case true:
      return (
        <>
          {requests.length > pageSize && (
            <Paginatio
              count={Math.ceil(requests.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}

          {renderStack({ requestStatusType })(s)(properties)({
            disableOperationsHelpDsk,
            expandRequestValue,
            toggleExpandRequest,
            now,
            selectedRequests,
            toggleRequestSelection,
            confirmCancelRequests,
          })(moreRequestData)(
            requests.slice((page - 1) * pageSize, page * pageSize)
          )}

          {requests.length > pageSize && (
            <Paginatio
              count={Math.ceil(requests.length / pageSize)}
              page={page}
              onChange={(z, page) => setPage(page)}
              shape="rounded"
            />
          )}
        </>
      );

    case void 0:
      return null;

    default:
      return <Container maxWidth="lg">Idk</Container>;
  }
}

const Paginatio = styled(Pagination)(({ theme }) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',

    '&>*+*': {
      marginTop: '0.5rem',
    },
  },

  itemWrapper: {
    paddingBottom: '0.5rem',
    borderBottom: variables.cardBorder,
  },

  line: {
    '&>*+*': {
      marginLeft: '1rem',
    },
  },

  label: {
    fontWeight: 700,
  },
}));
